import React from 'react';

const letters = ['S', 'Q', 'U', 'A', 'R', 'E', 'S'];

export default function Loading() {
  return (
    <div className="loading-screen">
      <div className="loading-tiles">
        {letters.map((letter, i) => (
          <div
            key={i}
            className="loading-tile"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            {letter}
          </div>
        ))}
      </div>
      <div className="loading-bar">
        <div className="loading-bar__fill" />
      </div>
    </div>
  );
}
